'use client'
import { faUserPen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'

export default function PulseButton({ link }: { link: string | null }) {
  return (
    <div className="fixed right-5 top-[85%] z-90">
      <Link
        href={link ? link : `https://wa.me/5516993174699?text=${encodeURIComponent('Olá! Gostaria de algumas informações. Pode me ajudar? Cupom #3FQC3WW2')}`}
        target="_blank"
        className="contents"
      >
        <button className="btn min-h-8 max-h-8 animate-pulsebtn rounded-none bg-verdeBtn px-1 py-1 pr-3 text-xs normal-case text-white hover:bg-verdeBtn border-0">
          <FontAwesomeIcon icon={faUserPen} width={40} className="inline" />
          <span className="-ml-4">Inscreva-se</span>
        </button>
      </Link>
    </div>
  )
}
